
<template>
  <!-- ////////////// -->
  <!-- Telco Prize Popup -->
  <!-- ////////////// -->
  <div data-backdrop="static" data-keyboard="false" class="modal fade prize telco" id="telco_prize_popup" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                @click="closeModal()">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
           <div class="modal-header">
            <h5 class="modal-title">10 Belminuten</h5>
            </div>
            <div class="modal-body">
              <img src="static/img/millen_images/icons/telco_icon_time.png" class="prize">
            </div>
          <div class="modal-footer">
            <p>
              Voorwaarden: Je gebruikt eerst je gratis ontvangen MB's, belminuten, sms’jes of Promo-tegoed. Deze Odido Surprises zijn geldig voor 7 dagen, binnen Nederland en servicenummers zijn uitgesloten. Het promo-tegoed is alleen beschikbaar bij een opwaardering vanaf 20 euro.
            </p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import gtm_analytics from "../../common/mixin/gtm_analytics";

  export default {
    name: 'PrizeMinutes',
    mixins: [
      gtm_analytics
    ],
    mounted() {
      $('#telco_prize_popup').modal('show')
      this.pushPopUp('Popup visit','Minute Reward Pop Up')
    },
    computed: {
      ...mapGetters([
        'isPrizeMinutesModalOpen'
      ])
    },
      methods: {
        ...mapMutations([
          'updatePrizeMinutesModal'
        ]),
        closeModal() {
          this.updatePrizeMinutesModal(false)
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/PrizeMinutes.vue